import React, {useEffect, useState} from "react";
import { useParams } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import DoneOutlineIcon from "@material-ui/icons/DoneOutline";
import useReducerOnChange from "../../hooks/ReducerOnChange";
import * as Glob from "../../Globale";
import * as Dati from "../../Dati";
import { Trad } from "../../components";
import { _MainContent, _PageTitle, _PageWrapper } from "../../inar2/layout";
import {_ButtonAPI, _BondData, _Button} from "../../inar2/components";
import ChiamaWeb, {CChiamaWebParametri} from "../../ChiamaWeb";

interface IRouteParam {
    CodiceControllo?: string;
    Polizza?: string;
}

export const _BondCheckCode: React.FC<Glob.IRouteGlobaleProps> = props => {
    const [Data, setData] = useState<Dati.CRisAPI_DatiPolizzaCodiceControllo>(new Dati.CRisAPI_DatiPolizzaCodiceControllo());
    const [FormData, setFormData] = useReducerOnChange({ CheckCode: useParams<IRouteParam>().CodiceControllo || "", Policy: useParams<IRouteParam>().Polizza || "" });
    const CodiceControllo = useParams<IRouteParam>().CodiceControllo;
    const Polizza = useParams<IRouteParam>().Polizza;
    
    useEffect(() => {
        if (CodiceControllo !== undefined && Polizza !== undefined)
        {
            const Param: CChiamaWebParametri = {
                URL: `/api/Polizza/ControlloCodiceControllo?codiceControllo=${CodiceControllo}&polizza=${Polizza}`,
                OnRis: OnCheck
            };
            new ChiamaWeb().Chiama(Param); 
        }
    }, [Polizza,CodiceControllo]);
    
    const OnCheck = (sender: ChiamaWeb, data: Dati.CRisAPI_DatiPolizzaCodiceControllo) => {
        if (data.Errore) {
            props.SetDialog({ Open: true, Title: "ERRORE", Content: data.ErrTesto, Type: "error" });
        } else {
            setData(data);
        }
    };

    const OnApiError = (error: Error) => {
        props.SetDialog({ Open: true, Title: "ERRORE", Content: error.message, Type: "error" });
    };

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={DoneOutlineIcon} Title="Controllo validità fideiussione" />
                <_MainContent WithPaper={false}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={3}>
                            <Card>
                                <CardContent>
                                    <form noValidate>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    value={FormData.Policy}
                                                    id="Policy"
                                                    label={Trad.Trad("NumeroPolizza")}
                                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    value={FormData.CheckCode}
                                                    id="CheckCode"
                                                    label={Trad.Trad("Codice controllo")}
                                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                                    fullWidth
                                                />
                                            </Grid>
                                        </Grid>
                                    </form>
                                </CardContent>
                                <CardActions disableSpacing>
                                    <Grid container item xs={12} justify="flex-end">
                                        <_Button
                                            Default
                                            Attivo
                                            Testo={Trad.Trad("Verifica")}
                                            OnClick={ () => props.history.push(`/fidecodicecontrollo/${FormData.CheckCode}/${FormData.Policy}`)}
                                        />
                                    </Grid>
                                </CardActions>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <_BondData Data={Data} />
                        </Grid>
                    </Grid>
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/BondCheckCode.tsx